import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';

/** 等待浏览器完成下一帧绘制（双 rAF，避免接口返回后遮罩过早消失） */
export function waitForNextPaint() {
	return new Promise((resolve) => {
		requestAnimationFrame(() => {
			requestAnimationFrame(resolve);
		});
	});
}

export function isPerformanceRulesBusy({ isRematching, isUpdating, isDeleting }) {
	return Boolean(isRematching || isUpdating || isDeleting);
}

export function getPerformanceRulesBusyLabel({ isRematching, isUpdating, isDeleting }) {
	if (isRematching) return '正在重新匹配绩效规则…';
	if (isUpdating) return '正在保存绩效规则…';
	if (isDeleting) return '正在删除绩效规则…';
	return '';
}

const PerformanceRulesRematchOverlay = ({ show, label = '正在重新匹配绩效规则…' }) => {
	if (!show) return null;

	return (
		<div
			className='position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-body rounded-2'
			style={{ zIndex: 5, minHeight: '4.5rem' }}
			role='status'
			aria-live='polite'
			aria-busy='true'
		>
			<Spinner animation='border' variant='primary' size='sm' />
			<span className='fs-10 text-600 mt-2 px-2 text-center'>{label}</span>
		</div>
	);
};

PerformanceRulesRematchOverlay.propTypes = {
	show: PropTypes.bool,
	label: PropTypes.string,
};

export default PerformanceRulesRematchOverlay;
